var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.31-414.62q-30.31 0-51.31-21-21-21-21-51.3v-237.7q0-9.69 4.04-18.57 4.04-8.89 10.88-15.73L216-950l23.08 23.08q4.84 4.84 8.27 12.23 3.42 7.38 3.42 14.07v7.23l-31.08 138.78h202.62q20.46 0 34.07 13.61Q470-727.38 470-706.92v32.3q0 6-1 11.12-1 5.11-3 10.11l-89.23 208.16q-6.23 14.31-18.85 22.46-12.61 8.15-27.92 8.15H82.31Zm241.84-59.99L410-676.31v-6q0-5.38-3.46-8.84-3.46-3.47-8.85-3.47H146.31l28.61-128.77L70-719.69v232.77q0 5.38 3.46 8.84 3.46 3.47 8.85 3.47h241.84ZM744-10l-23.08-23.08q-4.84-4.84-8.27-12.23-3.42-7.38-3.42-14.07v-7.23l31.08-138.78H537.69q-20.46 0-34.07-13.61Q490-232.62 490-253.08v-32.3q0-6 1-11.12 1-5.11 3-10.11l89.23-208.16q6.85-14.31 19.16-22.46 12.3-8.15 27.61-8.15h247.69q30.31 0 51.31 21 21 21 21 51.3v237.7q0 9.69-3.73 18.26-3.73 8.58-11.19 16.04L744-10ZM635.85-485.39 550-283.69v6q0 5.38 3.46 8.84 3.46 3.47 8.85 3.47h251.38l-28.61 128.77L890-240.31v-232.77q0-5.38-3.46-8.84-3.46-3.47-8.85-3.47H635.85ZM70-486.92v-232.77V-474.61v-12.31Zm820 13.84v232.77V-485.39v12.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpDown);
export default __webpack_public_path__ + "static/media/thumbs_up_down.25be0c1e49f0c36843b3fee9b23e9a30.svg";
export { ForwardRef as ReactComponent };